import React, { useState, useEffect, useCallback, FC } from 'react';
import c from './style.module.css';

interface IButton {
    title: string
    disabled?: boolean
    action?: (callback: () => void) => void
    type?: 'primary' | 'second'
    loading?: boolean
    size?: 'large'|'middle'|'small'
}

const Button: FC<IButton> = ({ title, type, action, disabled, loading, size }) => {
    type = type ? type : 'primary';
    size = size ? size : 'large';

    const [loadingState, setloadingState] = useState<boolean>(false);

    return (
        <div
            key={title + type}
            className={c.btn + ' ' + c[type] + ' ' + c[size] + ' ' + (disabled ? c.disabled : '') + (loading || loadingState ? c.loading : '')}
            onClick={() => {
                if (!action || disabled || loading)
                    return;

                setloadingState(true);

                const completeCallback = () => {
                    setloadingState(false);
                }

                action && action(completeCallback);
            }}
        >
            {title}
        </div>
    );
}

export default Button;